var $a0caa33f1e264489$exports = {};
$a0caa33f1e264489$exports = {
  "dragDescriptionKeyboard": "Pritisnite Enter da biste zapo\u010Deli prevla\u010Denje.",
  "dragDescriptionKeyboardAlt": "Pritisnite Alt + Enter da biste zapo\u010Deli prevla\u010Denje.",
  "dragDescriptionLongPress": "Pritisnite dugo da biste zapo\u010Deli prevla\u010Denje.",
  "dragDescriptionTouch": "Dvaput dodirnite da biste zapo\u010Deli prevla\u010Denje.",
  "dragDescriptionVirtual": "Kliknite da biste zapo\u010Deli prevla\u010Denje.",
  "dragItem": function dragItem(args) {
    return "Prevucite ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Prevucite ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " izabranu stavku");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " izabrane stavke");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Pritisnite Enter da biste prevukli ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " izabranu stavku");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " izabranih stavki");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Pritisnite Alt + Enter da biste prevukli ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " izabranu stavku");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " izabranih stavki");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Pritisnite dugo da biste prevukli ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " izabranu stavku");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " izabranih stavki");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Prevla\u010Denje je zapo\u010Deto. Pritisnite Tab da biste oti\u0161li do cilja za otpu\u0161tanje, zatim pritisnite Enter za ispu\u0161tanje ili pritisnite Escape za otkazivanje.",
  "dragStartedTouch": "Prevla\u010Denje je zapo\u010Deto. Idite do cilja za otpu\u0161tanje, a zatim dvaput dodirnite za otpu\u0161tanje.",
  "dragStartedVirtual": "Prevla\u010Denje je zapo\u010Deto. Idite do cilja za otpu\u0161tanje, a zatim kliknite ili pritinite Enter za otpu\u0161tanje.",
  "dropCanceled": "Otpu\u0161tanje je otkazano.",
  "dropComplete": "Prevla\u010Denje je zavr\u0161eno.",
  "dropDescriptionKeyboard": "Pritisnite Enter da biste otpustili. Pritisnite Escape da biste otkazali prevla\u010Denje.",
  "dropDescriptionTouch": "Dvaput dodirnite za otpu\u0161tanje.",
  "dropDescriptionVirtual": "Kliknite za otpu\u0161tanje.",
  "dropIndicator": "Indikator otpu\u0161tanja",
  "dropOnItem": function dropOnItem(args) {
    return "Otpusti na ".concat(args.itemText);
  },
  "dropOnRoot": "Otpusti na",
  "endDragKeyboard": "Prevla\u010Denje u toku. Pritisnite Enter da biste otkazali prevla\u010Denje.",
  "endDragTouch": "Prevla\u010Denje u toku. Dvaput dodirnite da biste otkazali prevla\u010Denje.",
  "endDragVirtual": "Prevla\u010Denje u toku. Kliknite da biste otkazali prevla\u010Denje.",
  "insertAfter": function insertAfter(args) {
    return "Umetnite posle ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Umetnite ispred ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Umetnite izme\u0111u ".concat(args.beforeItemText, " i ").concat(args.afterItemText);
  }
};
export { $a0caa33f1e264489$exports as default };